<template>
  <div class="verify">
    <p v-if="!authStore.isAuthenticated" class="auth-brand"><BrandLogo large /></p>
    <template v-if="state === 'working'">
      <h1>{{ $t('Confirming your e-mail...') }}</h1>
    </template>
    <template v-else-if="state === 'done'">
      <h1>{{ $t('E-mail confirmed') }}</h1>
      <p>{{ $t('Your account is ready. The programs are open to you now.') }}</p>
      <router-link :to="authStore.isAuthenticated ? '/' : '/login'" class="btn">
        {{ authStore.isAuthenticated ? $t('Go to the programs') : $t('Log in') }}
      </router-link>
    </template>
    <template v-else>
      <h1>{{ $t('This link did not work') }}</h1>
      <p>{{ message }}</p>
      <router-link :to="authStore.isAuthenticated ? '/' : '/login'" class="btn">
        {{ authStore.isAuthenticated ? $t('Back to the dashboard') : $t('Log in to get a new link') }}
      </router-link>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import api from '../api'
import BrandLogo from '../components/BrandLogo.vue'
import { useAuthStore } from '../stores/auth'
import { t } from '../i18n'

const route = useRoute()
const authStore = useAuthStore()
const state = ref('working')
const message = ref('')

onMounted(async () => {
  try {
    await api.post('/api/auth/verify-email', { token: String(route.query.token || '') })
    if (authStore.isAuthenticated) await authStore.fetchUser().catch(() => {})
    state.value = 'done'
  } catch (err) {
    message.value = t(err.response?.data?.detail || 'Could not reach the server.')
    state.value = 'failed'
  }
})
</script>

<style scoped>
.auth-brand {
  display: flex;
  justify-content: center;
  margin: 0 0 22px;
}

.verify {
  padding: 60px 20px;
  text-align: center;
}

.btn {
  display: inline-block;
  margin-top: 16px;
  padding: 10px 18px;
  border-radius: 6px;
  background: #4CAF50;
  color: white;
  text-decoration: none;
}
</style>
